import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface Recommendation {
  id: string;
  title: string;
  description: string;
  category: 'revenue' | 'retention' | 'efficiency' | 'communication';
  urgency: 'critical' | 'high' | 'medium' | 'low';
  urgencyScore: number;
  expectedImpactCents: number;
  expectedImpactFormatted: string;
  /** The model's own number; null when none backs the row. */
  confidence: number | null;
  evidenceSources: string[];
  causalNarrative: string | null;
  optimalTiming: string | null;
  targetEntities: Array<{ type: string; id: string; name: string }>;
}

interface NextBestActionResponse {
  result: {
    recommendations: Recommendation[];
    modelsConsulted: string[];
    generatedAt: string;
  };
}

export function useNextBestActions(limit = 5) {
  return useQuery({
    queryKey: ['next-best-actions', limit],
    queryFn: () => api<NextBestActionResponse>(`/v1/ml/next-best-actions?limit=${limit}`),
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}
